import React from 'react';
import { reduxForm } from 'redux-form';
import { formSettings } from './../settings';
import { FormattedMessage } from 'react-intl';
import Document from './../../../../../../components/document';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import mixpanel from 'mixpanel-browser';
import { DocumentInfo } from '../../../../../../utilities/documentTypes';
import { PERMISSIONS } from '../../../../../../components/document/types';
import { connect } from 'react-redux';
class RightToWorkStep extends React.Component {
    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'employee', step: 'RightToWorkStep' } });

        const { admin, client, getAdmin } = this.props;
        if (!admin) {
            getAdmin(client.admin_id);
        }
    }

    render() {
        const { handleSubmit, back, submitting, admin, docs } = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <div className="row section">
                    <div className="col-xs-12">
                        <FormattedMessage
                            id={'workRights.introText'}
                            defaultMessage={
                                'We need to confirm that you are able to work in the UK. Please provide evidence of your right to work in the UK. (e.g. British Passport, VISA.)'
                            }
                        />
                    </div>

                    <div className="col-xs-12 topOffset15">
                        <FormattedMessage
                            id={'workRights.instructionDocuments'}
                            defaultMessage={'For guidance on what evidence you need to provide see the document below.'}
                        />
                    </div>
                    <div className="col-xs-6 section">
                        <Document
                            {...DocumentInfo.types.ADMIN_UK_RIGHT_TO_WORK_INSTRUCTIONS}
                            view={{ showHeader: false, component: 'icon-download' }}
                            ownerRole={{ id: admin.id, type: 'admin' }}
                        />
                    </div>
                    <div className="col-xs-12 topOffset15">
                        <FormattedMessage id={'workRights.intr'} defaultMessage={'Please upload evidence documents below:'} />
                    </div>
                    <div className="col-xs-6">
                        <Document
                            {...DocumentInfo.types.CONTRACTOR_RIGHT_TO_WORK}
                            upload={{ limit: 3, permissions: PERMISSIONS.CLIENT_UPLOAD }}
                            view={{ showHeader: false, component: 'icon-download', remove: true }}
                            remove={true}
                        />
                    </div>
                </div>

                <WizardButtons disabled={submitting || !docs.list.length} back={{ action: back }} />
            </form>
        );
    }
}

const mapStateToProps = state => {
    const docType = DocumentInfo.types.CONTRACTOR_RIGHT_TO_WORK.docType;
    return {
        docs: state.documents[docType] || { list: [] }
    };
};

RightToWorkStep = reduxForm(formSettings)(RightToWorkStep);

export default connect(mapStateToProps, null)(RightToWorkStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/employee/rightToWork.jsx